import React, { useState } from 'react';
import {Chart, ArcElement} from 'chart.js'
import {Doughnut} from 'react-chartjs-2'
import './Chart.css'
import Form from '../expenseForm/Form';
import {default as api} from '../../../store/apiSlice'
import { chart_data, getLabels, getSum, getTotal } from '../../../helper/helper';

Chart.register(ArcElement)

  const config={
    data:{
      datasets: [{
        data: [300, 50, 100],
        backgroundColor: [
          'rgb(255, 99, 132)',
          'rgb(54, 162, 235)',
          'rgb(255, 205, 86)'
        ],
        hoverOffset: 4,
        borderRadius:30,
        spacing:10
      }]
    },
    options:{
      cutout:110
    }
  }

const ChartCom = () => {
 
   const {data, isFetching, isError, isSuccess} = api.useGetLabelsQuery()
  let grapData;

   if(isFetching){
    grapData = <div>Fetching</div>

   }else if(isSuccess){
    grapData = <>    
      {
   
       getLabels(data,'type').map(v=> <div className='flex justify-between' key={v._id}>
        <div className="flex py-2">                             
                    <div className={`w-2 h-2 rounded py-3 ${v.color}`}></div>                                                 
                 <p className='mx-2'>{v.type}</p>              
              </div>      
                <span className='mt-3'>{ Math.round(parseInt(v.percent) )??0}%</span>              
       </div>)
       
   
      }
    </>
    
   }else if(isError){
    grapData= 'Error'

   }

    return (
      <div className="">
        <div className='chart-header'>
           <div className="chart relative py-10">
            {
              <Doughnut {...chart_data(data)}>
               </Doughnut>
            }
            
              <h2 className='mb-0 font-bold title'>Total
            <span className='block text-3xl text-emerald-400'>${getTotal(data)??0}</span>
            </h2>
           </div>
            {/* { grapData} */}
            <div className="info1 mt-24">
              {
                grapData 
               
              }     
                 
            </div>
        
        </div>
         <Form />
        </div>
    );
};

export default ChartCom;
